export default "__VITE_ASSET__CLJQ8dQt__"